var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql, useQuery } from '@apollo/client';
var GET_USER_SETTING = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query getUserSetting($userId: ID!, $settingSlug: String!) {\n    getUserSetting(userId: $userId, settingSlug: $settingSlug) {\n      value\n    }\n  }\n"], ["\n  query getUserSetting($userId: ID!, $settingSlug: String!) {\n    getUserSetting(userId: $userId, settingSlug: $settingSlug) {\n      value\n    }\n  }\n"])));
/**
 * Fetch a single user-scoped setting by slug.
 *
 * The query requires a tenant context (`tenantId`); it is skipped until both
 * `userId` and `tenantId` are present. The hook returns the Apollo
 * `useQuery` result so callers can read `loading`, `data`, `error`, etc.
 *
 * Common setting slugs:
 *   - `'24-hour-time'`         → boolean (JSON-encoded string)
 *   - `'week-starting-day'`    → number  (JSON-encoded string)
 */
export var useGetUserSetting = function (userId, tenantId, settingSlug) {
    return useQuery(GET_USER_SETTING, {
        skip: !userId || !tenantId,
        variables: {
            userId: userId,
            settingSlug: settingSlug,
        },
        fetchPolicy: 'cache-and-network',
    });
};
var templateObject_1;
